export default __webpack_public_path__ + "assets/images/bf3a42812c52629bad44c048ec731cb0.gif";